import { useState, useEffect } from 'react';
import { FaWindows, FaVolumeUp } from 'react-icons/fa';

export const Taskbar = ({
  windows,
  activeWindowId,
  onWindowClick,
  onStartClick,
  onStartLaunch,
}) => {
  const [time, setTime] = useState(new Date());
  const [startMenuOpen, setStartMenuOpen] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  };

  const handleStartClick = () => {
    setStartMenuOpen(!startMenuOpen);
    if (onStartClick) onStartClick();
  };

  const handleStartLaunch = (shortcutId) => {
    if (onStartLaunch) onStartLaunch(shortcutId);
    setStartMenuOpen(false);
  };

  return (
    <>
      {/* Start Menu */}
      {startMenuOpen && (
        <div className="start-menu" data-testid="start-menu">
          <div className="start-menu-header">
            <div className="user-avatar"></div>
            <span className="user-name">User</span>
          </div>
          <div className="start-menu-content">
            <div className="start-menu-left">
              <div className="menu-item">
                <span className="menu-icon icon-mail"></span>
                <span>E-mail</span>
              </div>
              <div className="menu-item" onClick={() => handleStartLaunch('ie')}>
                <span className="menu-icon icon-web"></span>
                <span>Internet</span>
              </div>
              <div className="menu-item" onClick={() => handleStartLaunch('faceleak')}>
                <span className="menu-icon icon-web"></span>
                <span>FaceLeak</span>
              </div>
              <div className="menu-separator"></div>
              <div className="menu-item">
                <span className="menu-icon icon-folder"></span>
                <span>My Documents</span>
              </div>
              <div className="menu-item" onClick={() => handleStartLaunch('pictures')}>
                <span className="menu-icon icon-picture"></span>
                <span>My Pictures</span>
              </div>
              <div className="menu-item" onClick={() => handleStartLaunch('winamp')}>
                <span className="menu-icon icon-music"></span>
                <span>My Music</span>
              </div>
            </div>
            <div className="start-menu-right">
              <div className="menu-item">My Computer</div>
              <div className="menu-item">Control Panel</div>
              <div className="menu-item">Help and Support</div>
              <div className="menu-item">Search</div>
              <div className="menu-item">Run...</div>
            </div>
          </div>
          <div className="start-menu-footer">
            <button className="shutdown-btn">
              <span className="shutdown-icon">OFF</span> Shut Down (Data Retained)
            </button>
          </div>
        </div>
      )}

      {/* Taskbar */}
      <div className="taskbar" data-testid="taskbar">
        {/* Start Button */}
        <button
          className={`start-button ${startMenuOpen ? 'active' : ''}`}
          onClick={handleStartClick}
          data-testid="start-button"
        >
          <FaWindows size={16} />
          <span>start</span>
        </button>

        {/* Quick Launch */}
        <div className="quick-launch">
          <div className="taskbar-separator"></div>
        </div>

        {/* Window Buttons */}
        <div className="taskbar-windows">
          {windows.map((window) => (
            <button
              key={window.id}
              className={`taskbar-window-btn ${activeWindowId === window.id ? 'active' : ''} ${
                window.isMinimized ? 'minimized' : ''
              }`}
              onClick={() => onWindowClick(window.id)}
              data-testid={`taskbar-btn-${window.id}`}
            >
              <span className="taskbar-window-icon">{window.icon}</span>
              <span className="taskbar-window-title">{window.title}</span>
            </button>
          ))}
        </div>

        {/* System Tray */}
        <div className="system-tray" data-testid="system-tray">
          <div className="tray-icons">
            <FaVolumeUp size={14} className="tray-icon" />
          </div>
          <div className="taskbar-clock" data-testid="taskbar-clock">
            {formatTime(time)}
          </div>
        </div>
      </div>

      {/* Click overlay to close start menu */}
      {startMenuOpen && (
        <div
          className="start-menu-overlay"
          onClick={() => setStartMenuOpen(false)}
        />
      )}
    </>
  );
};

export default Taskbar;
